import { fetcher } from "@website/fetcher/fetcher";
import { NextRouter } from "next/router";
import { ChargeWalletBodyTypes, ChargeWalletResponseTypes } from "./types";
export const chargeWalletApiURL = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/wallet/v1/users/charge-wallet`;

export const ChargeWalletService = (
  payload: ChargeWalletBodyTypes,
  router: NextRouter
): Promise<ChargeWalletResponseTypes> =>
  fetcher(
    { url: chargeWalletApiURL, method: "POST", data: payload },
    router
  ).then(({ data }) => data);
